import clsx from "clsx";
import React from "react";

import { withRefProp } from "../../../utils/withRefProp";
import styles from "./ButtonGroup.module.scss";

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  children?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

const ButtonGroup = withRefProp((props: ButtonGroupProps) => {
  const { className, orientation = "horizontal", children, ref, ...otherProps } = props;

  const childrenWithDataButton = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && typeof child.type !== "string") {
      return React.cloneElement(child as React.ReactElement<{ "data-button"?: string }>, {
        "data-button": "true",
      });
    }
    return child;
  });

  return (
    <div
      ref={ref}
      className={clsx(styles.root, className)}
      data-deci-button-group="true"
      data-orientation={orientation}
      {...otherProps}
    >
      {childrenWithDataButton}
    </div>
  );
});

export default ButtonGroup;
